import prd_t11 from '../../../assets/images/prd_t11.png';
import prd_t10 from '../../../assets/images/prd_t10.png';
import prd_t9 from '../../../assets/images/prd_t9.png';
import prd_t8 from '../../../assets/images/prd_t8.png';
import prd_t5 from '../../../assets/images/prd_t5.png';
import prd_t6 from '../../../assets/images/prd_t6.png';
import prd_c30 from '../../../assets/images/prd_c30.png';
import prd_c40 from '../../../assets/images/prd_c40.png';
import prd_w3 from '../../../assets/images/prd_w3.png';
import prd_s100 from '../../../assets/images/prd_s100.png';

import Slider from 'react-slick';

export default function ProductSlider({}) {
  const products = [
    { image: prd_t11, model: 'T11', alt: 'T11', url: '/sub2_1_4' , desc: '마케팅 및 초협소 통로 배송 전문가'},
    { image: prd_t10, model: 'T10', alt: 'T10', url: '/sub2_1_1', desc: '배송과 동시에 강력한 마케팅'},
    { image: prd_t9, model: 'T9', alt: 'T9', url: '/sub2_1_3', desc: '고하중 중량' },
    { image: prd_t8, model: 'T8', alt: 'T8', url: '/sub2_1_2' , desc: '최적화된 컴팩트 디자인'},
    { image: prd_t6, model: 'T6', alt: 'T6', url: '/sub2_1_5' , desc: '가성비 최고의 모델'},
    { image: prd_t5, model: 'T5', alt: 'T5', url: '/sub2_1_5' , desc: '가성비 최고의 모델'},
    { image: prd_w3, model: 'W3', alt: 'W3', url: '/sub2_1_7' , desc: '보안성과 여러층 배송 가능'},

    { image: prd_c30, model: 'C30', alt: 'C30', url: '/sub2_3_1' , desc: '자동청소를위한 3in 1 솔루션 '},
    { image: prd_c40, model: 'C40', alt: 'C40', url: '/sub2_3_2' , desc: '중소형 공간에 최적화된 4in 1 상업용 청소 로봇'},


    { image: prd_s100, model: 'S100', alt: 'S100', url: '/sub2_2', desc: '고중량 운송로봇' },
  ];

  const settings = {
    dots: false,
    arrows: false,
    // infinite: true, 
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const handleProductClick = (url) => {
    window.location.href = url;
  };

  return (
    <>
      <div className="s2_1_1_sect4 pt-6">
        <div className="txt-center mb-4">
          <p className="prt-bold fs-40 fc-black1 lh-13 mb-2">
            크림봇 제품 전체 보기
          </p>
          <p className="prt-regular fs-20 fc-777">
            크림봇의 다양한 제품을 만나보세요.
          </p>
        </div>
        <div className="center">
          <Slider {...settings} className="prd_slider pb-10">
            {products.map((product, index) => (
              <div
                key={index}
                className="item pointer"
                onClick={() => handleProductClick(product.url)}
              >
                <div className="prd_card relative col-flex flex-center">
                  <img src={product.image} alt={product.alt} />
                  <div className="txts lh-15 absolute txt-center w-90 col-flex flex-center">
                    <p className="prt-semi-bold fs-24">
                      <span className="fc-black1">CREAMBOT</span>{' '}
                      <span className="gradient-text">{product.model}</span>
                    </p>
                    <p className="prt-regular fs-16 fc-777">
                  {product.desc}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </>
  );
}